var SENTRY_RELEASE;SENTRY_RELEASE={name: "piclo-universal", version: "1.0.0"};